import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { constructValue } from '@adornis/baseql/entities/construct.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLFieldDefinition } from '@adornis/baseql/metadata/types.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { BuddyUserMentee, BuddyUserMentor } from '@adornis/bh-matching-user/entities/buddy-user.js';
import type { CustomFieldMapping } from '../../frontend-entrypoint/matching-page-admin.js';

@Entity()
export class GlobalConfig extends MongoEntity {
  static override _class = 'GlobalConfig';
  static override _collectionName = 'global-config';

  @Field(type => String) signupClosedNoteEnglish: Maybe<string>;
  @Field(type => String) signupClosedNoteGerman: Maybe<string>;

  @Field(type => String) imprint: Maybe<string>;
  @Field(type => String) dataPrivacy: Maybe<string>;
}

export const getGlobalConfig = registerQuery({
  operationName: 'getGlobalConfig',
  type: () => GlobalConfig,
  resolve:
    () =>
    async (gqlFields: BaseQLSelectionSet<GlobalConfig>): Promise<GlobalConfig> => {
      const coll = await getRawCollection<Partial<EntityData<GlobalConfig>>>(GlobalConfig._collectionName);
      const query = { _id: 'SINGLETON', _class: GlobalConfig._class };
      const existsAlready = await coll.findOne(query);
      if (existsAlready) return constructValue(existsAlready);
      await coll.insertOne(query);
      return constructValue(await coll.findOne(query));
    },
});

export const configRegistry = {
  fieldsOverride: null as
    | null
    | ((userClass: typeof BuddyUserMentor | typeof BuddyUserMentee) => BaseQLFieldDefinition[])
    | undefined,
  mentorCustomFieldMapping: null as null | CustomFieldMapping | undefined,
  menteeCustomFieldMapping: null as null | CustomFieldMapping | undefined,
};
